import type { Theme } from '@/shared/lib/theme';

/**
 * Оформление на случай, когда сервер не ответил.
 *
 * Боевая тема живёт в базе, и это правильно: заказчик меняет цвет, не
 * трогая код. Но в разработке база поднимается не всегда — чтобы
 * посмотреть экраны, достаточно фронта, — а без темы виджет показывал бы
 * заказчику чужие цвета и выглядел бы сломанным.
 *
 * Поэтому здесь лежит тот же набор значений, что и в засеве базы. Пара
 * должна совпадать: правишь одно — правь и второе. Это осознанный размен,
 * единственная альтернатива — поднимать базу ради каждого взгляда на вёрстку.
 *
 * NOTE: пара к infra/init-db/008_seed_fosy.sql.
 */
const FOSY: Theme = {
  bg: '#FFFFFF',
  surface: '#F3EEE8',
  'surface-raised': '#FFFFFF',
  'surface-sunken': '#F3EEE8',
  stage: '#F3EEE8',
  control: '#E6D4EE',
  accent: '#8661A1',
  'accent-ink': '#FFFFFF',
  'accent-hi': '#9B76B6',
  'accent-wash': 'rgb(134 97 161 / 12%)',
  text: '#454545',
  'text-muted': '#8A8A8A',
  'header-from': '#FFFFFF',
  'header-to': '#FFFFFF',
  'radius-card': '18px',
};

/**
 * СИЯЙ: чёрное по белому.
 *
 * У заказчиков цвет — это характер, а здесь характера нет намеренно:
 * витрина показывает чужие принты, и любой фирменный цвет вокруг спорил
 * бы с ними. Поэтому фон белый, управление чёрное, цветное на экране
 * только то, что человек покупает.
 *
 * NOTE: пара к infra/init-db/011_seed_siyai.sql.
 */
const SIYAI: Theme = {
  bg: '#FFFFFF',
  surface: '#F4F4F5',
  'surface-raised': '#FFFFFF',
  'surface-sunken': '#F4F4F5',
  stage: '#FFFFFF',
  control: '#F4F4F5',
  accent: '#111111',
  'accent-ink': '#FFFFFF',
  'accent-hi': '#2B2B2B',
  'accent-wash': 'rgb(17 17 17 / 8%)',
  text: '#111111',
  'text-muted': '#8A8A8F',
  'header-from': '#FFFFFF',
  'header-to': '#FFFFFF',
  'radius-card': '16px',
};

const THEMES: Record<string, Theme> = {
  fosy: FOSY,
  siyai: SIYAI,
};

/** Запасная тема партнёра. Пустая — значит остаётся тема по умолчанию. */
export function demoTheme(slug: string): Theme {
  return THEMES[slug] ?? {};
}
